"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postCopyContainsUrl = exports.xPostUrl = void 0;
/** Build a stable X status URL from a published tweet id (`posts.ref_id`). */
const xPostUrl = (tweetId) => `https://x.com/i/web/status/${tweetId.trim()}`;
exports.xPostUrl = xPostUrl;
/** Detect http(s) URLs in post copy (used for X link-cost operator awareness). */
const URL_IN_COPY = /(?:https?:\/\/|www\.)[^\s<>"']+/i;
const postCopyContainsUrl = (content) => URL_IN_COPY.test(content);
exports.postCopyContainsUrl = postCopyContainsUrl;
